import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

const FullScreenDropdown = () => {
  const [isFullscreen, setIsFullscreen] = useState(Boolean(document.fullscreenElement));

  const syncFullscreenState = useCallback(() => {
    const fullscreen = Boolean(document.fullscreenElement);
    setIsFullscreen(fullscreen);
    document.body.classList.toggle("fullscreen-enable", fullscreen);
  }, []);

  useEffect(() => {
    document.addEventListener("fullscreenchange", syncFullscreenState);
    syncFullscreenState();

    return () => {
      document.removeEventListener("fullscreenchange", syncFullscreenState);
      document.body.classList.remove("fullscreen-enable");
    };
  }, [syncFullscreenState]);

  const toggleFullscreen = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await document.documentElement.requestFullscreen();
      }
    } catch (error) {
      document.body.classList.remove("fullscreen-enable");
      setIsFullscreen(false);
    }
  };
  return (
    <React.Fragment>
      <div className="ms-1 header-item d-none d-sm-flex">
        <Button
          onClick={toggleFullscreen}
          type="button"
          className="btn-icon btn-topbar btn-ghost-dark rounded-circle"
          aria-label={isFullscreen ? "Exit full screen" : "Enter full screen"}
          aria-pressed={isFullscreen}
          title={isFullscreen ? "Exit full screen" : "Full screen"}
        >
          <i
            className={`bi ${isFullscreen ? "bi-fullscreen-exit" : "bi-arrows-fullscreen"}`}
            aria-hidden="true"
          ></i>
        </Button>
      </div>
    </React.Fragment>
  );
};

export default FullScreenDropdown;
